import * as R from 'ramda';

import {
    GET_PROFILE
} from './constants';

const defaultState = {
    profile: {}
};

const user = (state = defaultState, { type, payload }) => {
    switch (type) {
        case GET_PROFILE:
            return R.merge(state, { profile: payload });
        default:
            return state
    }
};

export default user;
